"use client";
import { jsxs as t, jsx as i } from "react/jsx-runtime";
const n = ({
  title: l,
  titleId: r,
  desc: a,
  descId: c,
  ...e
}) => /* @__PURE__ */ t(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": r,
    "aria-describedby": c,
    ...e,
    children: [
      a ? /* @__PURE__ */ i("desc", { id: c, children: a }) : null,
      l ? /* @__PURE__ */ i("title", { id: r, children: l }) : null,
      /* @__PURE__ */ i("path", { d: "M373.4063 0H138.5938C62.1718 0 0 62.1719 0 138.5938v234.8164C0 449.8282 62.1719 512 138.5938 512h234.8164C449.8282 512 512 449.8281 512 373.4102V138.5938C512 62.1718 449.8281 0 373.4063 0m108.578 373.4102c0 59.8671-48.707 108.5742-108.578 108.5742H138.5938c-59.8711 0-108.5782-48.707-108.5782-108.5742V138.5938c0-59.8711 48.707-108.5782 108.5782-108.5782h234.8164c59.8671 0 108.5742 48.707 108.5742 108.5782zm0 0" }),
      /* @__PURE__ */ i("path", { d: "M256 116.004c-77.1953 0-139.996 62.8007-139.996 139.996S178.8046 395.996 256 395.996 395.996 333.1954 395.996 256 333.1954 116.004 256 116.004m0 249.9765c-60.6406 0-109.9805-49.336-109.9805-109.9805 0-60.6406 49.3399-109.9805 109.9805-109.9805 60.6445 0 109.9805 49.3399 109.9805 109.9805 0 60.6445-49.336 109.9805-109.9805 109.9805M399.3438 66.2852c-22.8125 0-41.3672 18.5585-41.3672 41.3671 0 22.8125 18.5546 41.3711 41.3671 41.3711s41.3711-18.5586 41.3711-41.371-18.5586-41.3672-41.371-41.3672m0 52.7187c-6.2579 0-11.3516-5.0937-11.3516-11.3516 0-6.2617 5.0937-11.3515 11.3515-11.3515 6.2618 0 11.3555 5.0898 11.3555 11.3515 0 6.2579-5.0937 11.3516-11.3555 11.3516m0 0" })
    ]
  }
);
export {
  n as default
};
